/* eslint-disable prefer-destructuring */
import math from '../maths';
import formatNumber from './formatNumber';
import formatToFixed from './formatToFixed';

const { div } = math;
const { formatToFixed2 } = formatToFixed;
/**
 * @param val  // 输入的需求数量
 * @param minNum //起订量
 * @param packStandard //包装规格
 * @param saleUom //包装单位
 */

const inventoryCal = (val, minNum, packStandard, saleUom, saleUomDesc, lineQty = true) => {
  if (!!packStandard && !!minNum) {
    const value = val ? val : 0;
    const packArray = packStandard.split(' <BR />');
    let packItem = null;
    let packCount = 0;
    let unit = '箱';
    // 多少支 或者多少公斤
    const invenCount = lineQty ? Math.ceil(div(value, minNum)) * minNum : value;
    if (saleUom === 'MP' || saleUom === 'PC') {
      packArray.forEach((item) => {
        packItem = item.split('/');
        if (packItem[1] === '箱') {
          unit = packItem[1];
          packCount = packItem[0];
        }
      });

      // 多少箱
      let invenBoxCount = '0箱';
      if (!!packCount) {
        invenBoxCount = `${formatNumber(formatToFixed2(div(invenCount, packCount)))}${unit}`;
      }
      return [`${formatNumber(invenCount)}支`, invenBoxCount];
    } else {
      return [`${formatNumber(invenCount)}${saleUomDesc}`];
    }
  } else {
    if (saleUom === 'MP' || saleUom === 'PC') {
      return [`${formatNumber(val)}支`, '0箱'];
    } else {
      return [`${formatNumber(val)}公斤`]; // todo
    }
  }
};

export default inventoryCal;
